@let current = selected();

<button
  type="button"
  (click)="dropdown.toggle()"
  aria-haspopup="listbox"
  [attr.aria-expanded]="dropdown.isOpen()"
  [attr.aria-label]="'Location: ' + current.label"
  class="flex items-center gap-2 rounded-lg bg-white py-1.5 pl-2 pr-3 text-sm font-medium text-gray-900 shadow-sm ring-1 ring-gray-200 hover:bg-gray-50 transition-colors"
>
  <app-location-avatar size="sm" [location]="current.location" />
  <span class="truncate max-w-44">{{ current.label }}</span>
  <app-icon name="chevron" class="w-4 h-4 text-gray-400 transition-transform" [class.rotate-180]="dropdown.isOpen()" />
</button>

@if (dropdown.isOpen()) {
  <div class="absolute left-0 z-30 mt-2 w-72 rounded-2xl bg-white p-1.5 shadow-xl ring-1 ring-gray-200">
    <ul
      cdkListbox
      [cdkListboxValue]="[value()]"
      (cdkListboxValueChange)="dropdown.choose($event, value)"
      aria-label="Locations"
      class="max-h-80 overflow-y-auto focus:outline-none"
    >
      @for (option of options(); track option.id) {
        @let active = option.id === current.id;
        <li
          [cdkOption]="option.id"
          [cdkOptionTypeaheadLabel]="option.label"
          class="flex cursor-pointer items-center gap-3 rounded-xl px-2.5 py-2 transition-colors hover:bg-gray-50 aria-selected:bg-blue-50/60 [&.cdk-option-active]:bg-gray-100"
        >
          <app-location-avatar [location]="option.location" />
          <span class="min-w-0 flex-1">
            <span class="block truncate text-sm" [class]="active ? 'font-semibold text-gray-900' : 'font-medium text-gray-800'">
              {{ option.label }}
            </span>
            @if (option.city) {
              <span class="block truncate text-xs text-gray-400">{{ option.city }}</span>
            }
          </span>
          @if (active) {
            <app-icon name="check" class="w-4 h-4 text-[#0A84FF]" />
          }
        </li>

        <!-- Divider between "All locations" and the individual locations -->
        @if ($first && !$last) {
          <li role="separator" class="my-1 h-px bg-gray-100"></li>
        }
      }
    </ul>
  </div>
}
